var CreditsListItem          = require("./CreditsListItem"),
    RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    SimpleRepeater           = require("enyo-ui/SimpleRepeater"),
    kind                     = require("enyo/kind");

module.exports = kind(/** @lends  app.MediaDetailPopup.CreditsList.prototype */ {

    /**
     * @private
     */
    name: "app.MediaDetailPopup.CreditsList",

    /**
     * @private
     */
    kind: SimpleRepeater,

    /**
     * @private
     */
    classes: "app-media-detail-popup-credits-list",

    /**
     * @private
     */
    tag: "dl",

    /**
     * Simple array support, refreshes the entire view when data changes.
     *
     * @type {enyo-ui.RepeaterArrayDataAdapter}
     * @public
     */
    dataAdapterKind: RepeaterArrayDataAdapter,

    /**
     * The kind that will be rendered for each item in the dataset.
     *
     * @type  {enyo.Control}
     * @public
     */
    childKind: CreditsListItem

});
